<app-header />

<main class="app-main">
  <router-outlet />
</main>
